<!-- InfoCard.vue -->
<template>
  <div class="card dn-card" :class="{ 'invisible': invisible }" style="background-color: rgb(210, 210, 210);" @click="handleClick">
    <div class="row no-gutters dn-row">
      <div class="dn-card-body">
        <div class="card-body">
          <h5 class="card-title dn-font-14">{{ title }}</h5>
        </div>
      </div>
      <div class="dn-card-svg">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor"
             class="bi bi-chevron-right" viewBox="0 0 16 16">
          <path fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoCard',
  props: {
    title: { type: String, required: true },
    invisible: { type: Boolean, default: false }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>
<style scoped>
.dn-card {
    width: 21.5rem;
    height: 6rem;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0.5rem;
    text-align: left;
    border-radius:15px 15px 15px 15px;
}

.dn-card-svg {
    float:right;
    align-items: center;
    display: flex;
}

.dn-card-body {
    float: left;
    width: 90%;
}

.dn-row {
    padding-top: 0.9rem;
}
</style>


// WEBPACK FOOTER //
// src/components/InfoCard.vue